import { render, staticRenderFns } from "./MyPageTasks.vue?vue&type=template&id=33e37be6&scoped=true&"
import script from "./MyPageTasks.vue?vue&type=script&lang=js&"
export * from "./MyPageTasks.vue?vue&type=script&lang=js&"
import style0 from "./MyPageTasks.vue?vue&type=style&index=0&id=33e37be6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e37be6",
  null
  
)

export default component.exports